// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("./img/grid.svg", import.meta.url);
var ___HTML_LOADER_IMPORT_1___ = new URL("./img/jsoneditor.svg", import.meta.url);
var ___HTML_LOADER_IMPORT_2___ = new URL("./img/save.svg", import.meta.url);
// Module
var code = `<div class="gridstack-toolbar edit-mode">
  <div class="toolbar-action" id="add-grid"><img src="${___HTML_LOADER_IMPORT_0___}" class="toolbar-img" alt="grid"></div>
  <div class="toolbar-action" id="edit-json"><img src="${___HTML_LOADER_IMPORT_1___}" class="toolbar-img" alt="edit"></div>
  <div class="toolbar-action" id="save-config"><img src="${___HTML_LOADER_IMPORT_2___}" class="toolbar-img" alt="save"></div>
</div>
<div id="gridstack" class="grid-stack"></div>

`;
// Exports
export default code;